var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.316,
    height: 20.316,
    viewBox: "0 0 20.316 20.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .info_svg_icon {\n        fill: #16151a;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    className: "info_svg_icon",
    d: "M10.158,0A10.158,10.158,0,1,0,20.316,10.158,10.17,10.17,0,0,0,10.158,0Zm0,18.47a8.311,8.311,0,1,1,8.311-8.311A8.321,8.321,0,0,1,10.158,18.47Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    className: "info_svg_icon",
    d: "M146.233,70a1.231,1.231,0,1,0,1.231,1.232A1.233,1.233,0,0,0,146.233,70Z",
    transform: "translate(-136.075 -65.69)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    className: "info_svg_icon",
    d: "M150.923,140a.923.923,0,0,0-.923.923v5.541a.923.923,0,0,0,1.847,0v-5.541A.923.923,0,0,0,150.923,140Z",
    transform: "translate(-140.765 -131.381)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.f4fa90860d97c362882238fdcb69c7aa.svg";
export { ForwardRef as ReactComponent };